/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

import Auth0ProviderWithNavigate from './components/Auth0';

// Soft UI Context Provider
import { SoftUIControllerProvider } from "context";


import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'


import { ReactQueryDevtools } from '@tanstack/react-query-devtools'


// Create a client
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Auth0ProviderWithNavigate>
    <QueryClientProvider client={queryClient}>
      

        <SoftUIControllerProvider>

          <App />

        </SoftUIControllerProvider>

      
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </Auth0ProviderWithNavigate>
);